module.exports = __webpack_public_path__ + "static/img/banner.e66cede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/banner.png
// module id = r8j8
// module chunks = 44